// formulaire de mof=dification de projet

import React, { useState } from "react";
import "./editerProjet.css";
import axios from "axios";
import { API_ROUTES } from "../../utils/constant";
import { Link } from "react-router-dom";

const EditerProjet = () => {
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [description, setDescription] = useState("");
  const [URL, setURL] = useState("");
  const [github, setGithub] = useState("");
  const [Technologies, setTechnologies] = useState("");
  const [message, setMessage] = useState("");

  const handleImageChange = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      setImageFile(selectedImage);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("title", title);
      formData.append("image", imageFile);
      formData.append("description", description);
      formData.append("URL", URL);
      formData.append("github", github);
      formData.append("technologies", Technologies);

      const response = await axios.put(
        `${API_ROUTES.PROJETS}/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setId("");
        setTitle("");
        setImageFile(null);
        setDescription("");
        setURL("");
        setGithub("");
        setTechnologies("");
        setMessage("Projet modifié avec succès !");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div className="editer-projet">
      <h2>Editer un projet</h2>
      <form onSubmit={handleSubmit}>
        <div className="editer-projet-input">
          <label htmlFor="id">ID</label>
          <input
            type="text"
            id="id"
            value={id}
            onChange={(event) => setId(event.target.value)}
          />
        </div>
        <div className="editer-projet-input">
          <label htmlFor="title">Titre</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </div>
        <div className="editer-projet-input">
          <label htmlFor="image">Image</label>
          <input
            type="file"
            id="image"
            name="image"
            accept="image/png, image/jpeg"
            onChange={(event) => handleImageChange(event)}
          />
        </div>
        <div className="editer-projet-input">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </div>
        <div className="editer-projet-input">
          <label htmlFor="URL">URL</label>
          <input
            type="text"
            id="URL"
            value={URL}
            onChange={(event) => setURL(event.target.value)}
          />
        </div>
        <div className="editer-projet-input">
          <label htmlFor="github">Github</label>
          <input
            type="text"
            id="github"
            value={github}
            onChange={(event) => setGithub(event.target.value)}
          />
        </div>
        <div className="editer-projet-input">
          <label htmlFor="Technologies">Technologies</label>
          <input
            type="text"
            id="Technologies"
            value={Technologies}
            onChange={(event) => setTechnologies(event.target.value)}
          />
        </div>
        <button type="submit">Editer</button>
        {message && <p className="message-success">{message}</p>}
        <Link to="/admin">Retour</Link>
      </form>
    </div>
  );
};

export default EditerProjet;
